import { SBack, SGeneralForms, SListTabs, STitle, SDrawerOrModal } from 'shj-components'
import { Button, Popconfirm, Skeleton, Tooltip, Space, Popover, message } from 'antd'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { InfoCircleOutlined } from '@ant-design/icons'
import { getQuoteGoodsList, orderGetButton, selectRefActivityOrder } from '@/services/order'
import StartWorkPending from "@/pages/orderService/components/StartWorkPending.tsx";
import PaymentDetails from './detailTables/paymentDetails'
import WhiteListApprove from '@/components/WhiteListApprove'
import ExpectedStartWorkTime from '@/pages/orderService/components/ExpectedStartWorkTime.tsx'
import dayjs from 'dayjs'
import actBannerActOrigin from '@/assets/act-banner-act.png';
import actBannerAct from '@/assets/act-banner-act-v2.png';
import QuotaList from './detailTables/quotaList'
import ContractList from './detailTables/contractList'
import PaymentList from './detailTables/paymentList'
import ExcessiveDiscount from './detailTables/excessiveDiscount'
import TransactionList from './detailTables/transactionList'
import AddQuotationDrawer from './addQuotationDrawer'
import ReFundDrawer from './refundDrawer'
import SubmitWork from '../components/SubmitWork'
import ExcessDiscount from '../components/excessDiscount'
import AbnormalRefund from '../components/abnormalRefund'
import RefundSign from './refundSign'
import RefundBalance from './refundBalance'
import EditCommodityModal from './EditCommodityModal'
import ChangeAddress from './changeAddress'
import LinkJd from './linkJd'
import JdReceivables from './detailTables/jdReceivables'
import AddJdPaymentAplly from './addJdPaymentApply'
import styles from '../index.module.less'

export default function OrderServiceDetails() {
  const navaigate = useNavigate()
  const { id } = useParams() // 订单id
  const orderRef = useRef<any>()
  const listRef1 = useRef()
  const jdTableRef = useRef()
  const [search] = useSearchParams()
  const [open, setOpen] = useState(false)
  const [openRefund, setOpenRefund] = useState(false)
  const [submitWorkOpen, setSubmitWorkOpen] = useState(false)
  const orderItemId = search.get('orderItemId')
  const [detailsInfo, setDetailsInfo] = useState<any>(null) // 商品详情信息
  const [refundSignOpen, setRefundSignOpen] = useState<any>(false)
  const [refundBalanceOpen, setRefundBalanceOpen] = useState<any>(false)
  const [excessDiscountOpen, setExcessDiscountOpen] = useState<any>(false)
  const [abnormalRefundOpen, setAbnormalRefundOpen] = useState<any>(false)
  const [openEditCommodityModal, setOpenEditCommodityModal] = useState(false)
  const [changeAddressOpen, setChangeAddressOpen] = useState<any>(false)
  const [linkToJDOpen, setLinkToJDOpen] = useState<any>(false)
  const [addJdOpen, setAddJdOpen] = useState<any>(false)
  const [startWorkPendingOpen, setStartWorkPendingOpen] = useState<any>(false)//开工待定
  const [showApproverSubmit, setShowApproverSubmit] = useState(false);
  const [predictStartTimeOpen, setPredictStartTimeOpen] = useState<any>(false)//预计开工日期
  const [gaveActivityType, setGaveActivityType] = useState(''); // 整装产生优惠券订单：'gave', 软装使用优惠券订单: 'gain',
  const [gainActivityType, setGainActivityType] = useState(''); // 整装产生优惠券订单：'gave', 软装使用优惠券订单: 'gain',
  const [gainOrderIdList, setGainOrderIdList] = useState([])
  const [gaveOrderIdList, setGaveOrderIdList] = useState([])

  const getMoreBtnToolTip = (state = false) => {
    return state ? '当前状态不可操作' : '只能操作归属于自己的报价'
  }
  const [items, setItems] = useState<any>([])

  const handleOpenEditModal = () => {
    setOpenEditCommodityModal(true)
  }

  const baseInfoConfig: any = [
    {
      // title: '基础信息',
      formItem: [
        {
          name: 'orderNo',
          label: '订单号',
          spanCol: 6,
        },
        {
          name: 'name',
          label: '商品名称',
          spanCol: 6,
          children: (
            <>
              <span style={{ color: 'rgb(153, 153, 153)' }}>{detailsInfo?.name}</span>
              {detailsInfo?.replaceFlag ? (
                <span
                  onClick={handleOpenEditModal}
                  style={{ marginLeft: 10, color: '#1677FF', cursor: 'pointer' }}
                >
                  修改
                </span>
              ) : null}
            </>
          ),
        },
        {
          name: 'bizTagDisplay',
          label: '需求标签',
          spanCol: 6,
        },
        {
          name: 'totalPrice',
          label: '金额',
          spanCol: 6,
          children: (
            <span style={{ color: 'rgb(153, 153, 153)' }}>
              {detailsInfo?.totalPrice || detailsInfo?.totalPrice == 0 ? (
                <>
                  ￥{detailsInfo?.totalPrice}
                  <Tooltip
                    title={
                      <>
                        <div>合同金额： ￥{detailsInfo?.contractAmount}</div>
                        <div>其他收款金额： ￥{detailsInfo?.otherAmount}</div>
                      </>
                    }
                  >
                    <InfoCircleOutlined style={{ color: 'rgb(10, 10, 10)', marginLeft: 5 }} />
                  </Tooltip>
                </>
              ) : (
                ''
              )}
            </span>
          ),
        },
        {
          name: 'customerName',
          label: '客户信息',
          spanCol: 6,
          children: (
            <span style={{ color: 'rgb(153, 153, 153)' }}>
              {`${detailsInfo?.customerName ? detailsInfo?.customerName : ''} ${
                detailsInfo?.customerPhone ? detailsInfo?.customerPhone : ''
              }`}
            </span>
          ),
        },
        {
          name: 'clueId',
          label: '线索ID',
          spanCol: 6,
        },
        {
          name: 'trackId',
          label: '商机ID',
          spanCol: 6,
        },
        {
          name: 'thirdOrderNo',
          label: '三方订单',
          spanCol: 6,
          isDeps: true,
          deps: () => detailsInfo?.thirdOrderNo,
          children: (
            <span>{`【${
              { JD: '京东' }[detailsInfo?.sourceType]
            }】${detailsInfo?.thirdOrderNo}`}</span>
          ),
        },
        {
          name: 'createdByName',
          label: '创建人',
          spanCol: 6,
        },
        {
          name: 'createdTime',
          label: '创建时间',
          spanCol: 6,
          type: 'dateTime',
        },
        {
          name: 'stateDisplay',
          hidden: !detailsInfo?.stateDisplay,
          label: '商品状态',
          spanCol: 6,
        },
        {
          name: 'expectProjectStartDate',
          label: '预计开工日期',
          spanCol: 6,
          children: (
            <span style={{color:'rgb(153, 153, 153)'}}>{detailsInfo?.expectProjectStartDate?dayjs(Number(detailsInfo?.expectProjectStartDate)).format('YYYY-MM-DD') : '-'}</span>
          )
        },
      ],
    },
  ]
  // 页面初始化
  useEffect(() => {
    reloadPage()
    return () => {
      document.title = '积木云装'
    }
  }, [])
  const init = async () => {
    try {
      const data: any = await getQuoteGoodsList({
        data: {
          orderId: id,
          queryExpectProjectStartDate:true
        },
      })
      if (data && data.length) {
        let items = [
          {
            key: '1',
            label: '报价信息',
            destroyInactiveTabPane: true,
            children: (
              <QuotaList ref={listRef1} orderId={id} detail={{ ...data[0] }} reloadDetail={() => init()} />
            ),
          },
          {
            key: '2',
            label: '合同',
            destroyInactiveTabPane: true,
            children: (
              <ContractList
                getToolTip={getMoreBtnToolTip}
                detail={{ ...data[0] }}
                listRef1={listRef1}
              />
            ),
          },
          {
            key: '3',
            label: '应收明细',
            destroyInactiveTabPane: true,
            children: <PaymentList />,
          },
          {
            key: '4',
            label: '交易流水',
            destroyInactiveTabPane: true,
            children: <PaymentDetails id={ data?.[0]?.orderAccountId || '' } orderId={id} />,
          },
          {
            key: '5',
            label: '服务人员',
            destroyInactiveTabPane: true,
            children: <TransactionList detail={{ ...data[0] }} orderItemId={orderItemId} />,
          },
          {
            key: '6',
            label: '超标优惠',
            destroyInactiveTabPane: true,
            children: <ExcessiveDiscount ref={listRef1} />,
          },
        ]
        console.log('获取详情-----------', { ...data[0] })
        setDetailsInfo({ ...data[0] })
        document.title = data?.[0]?.customerName
        if (data[0].sourceType === 'JD') {
          setItems([
            ...items,
            {
              key: '7',
              label: '京东收款',
              destroyInactiveTabPane: true,
              children: (
                <JdReceivables detail={{ ...data[0] }} orderItemId={orderItemId} ref={jdTableRef} />
              ),
            },
          ])
        } else {
          setItems([...items])
        }
        await getActivityInfo(data?.[0]?.orderId);
      }
    } catch (err) {
      console.log(err)
    }
  }

  const getActivityInfo = async (orderId: any) => {
    try {
      const res: any = await selectRefActivityOrder({
        params: {
          orderId
        },
      })
      if (res?.refGaveCouponOrderIdList?.length) {
        setGaveActivityType('gave')
        setGaveOrderIdList(res?.refGaveCouponOrderIdList)
      }
      if (res?.refGainCouponOrderIdList?.length) {
        setGainActivityType('gain')
        setGainOrderIdList(res?.refGainCouponOrderIdList)
      }
      if (!res?.refGainCouponOrderIdList?.length && !res?.refGaveCouponOrderIdList?.length) {
        setGainActivityType('')
        setGaveActivityType('')
        setGainOrderIdList([])
        setGaveOrderIdList([])
      }
    } catch (err) {
      console.log(err)
    }
  }

  // 签约型商品 退款
  const handleReFund = () => {
    setOpenRefund(true)
  }
  // 图纸管理
  const drawingManagementHandle = (detailsInfo: any) => {
    const quoteGoodsId = detailsInfo.id // 取得是商品报价id
    navaigate(`/order/list/details/drawing-management/${quoteGoodsId}/${id}?frozenFlag=${detailsInfo?.frozenFlag}`)
  }

  const getToolTip = item => {
    const { key, name, click, disabled, type } = item
    if (item.render) {
      return item.render
    }
    return (
      <Button key={key} disabled={disabled} onClick={e => click(detailsInfo)} type={type}>
        {name}
      </Button>
    )
  }
  // 新增报价
  const handleAddQuotation = () => {
    setOpen(true)
  }

  // 提开工
  const handleSubmitWorkBtn = () => {
    setSubmitWorkOpen(true)
  }
  // 退单重签
  const handleRefundSign = () => {
    setRefundSignOpen(true)
  }
  // 退余额
  const handleRefundBalance = () => {
    setRefundBalanceOpen(true)
  }
  // 申请超标优惠
  const handleExcessDiscount = () => {
    setExcessDiscountOpen(true)
  }
  // 提交开工锁定
  // const handleStartWorkLock = () => {
  //   setStartWorkLockOpen(true)
  // }
  // 提交开工待定
  const handleStartWorkPending = () => {
    setStartWorkPendingOpen(true)
  }
  // 申请异常退单
  const handleAbnormalRefund = () => {
    setAbnormalRefundOpen(true)
  }
  // 定制图纸
  const customizedDrawingsHandle = (detailsInfo: any) => {
    const quoteGoodsId = detailsInfo.id // 取得是商品报价id
    navaigate(`/order/list/details/customized-drawings/${quoteGoodsId}/${id}`)
  }
  // 楼盘地址变更
  const handleChangeAddress = () => {
    setChangeAddressOpen(true)
  }
  // 关联京东
  const contactJD = () => {
    setLinkToJDOpen(true)
  }
  // 发起京东收款
  const addOrUpdatePaymentApply = () => {
    setAddJdOpen(true)
  }
  // 预计开工日期
  const handlePredictStartTime = () => {
    setPredictStartTimeOpen(true)
  }

  const [btns, setBtns] = useState<any>([
    {
      key: 'predict_start_time',
      name: '预计开工日期',
      click: handlePredictStartTime,
    },
    {
      key: 'submit_be_pending',
      name: '提交开工延期',
      click: handleStartWorkPending,
    },
    // {
    //   key: 'submit_be_lock',
    //   name: '提交开工锁定',
    //   click: handleStartWorkLock,
    // },
    {
      key: 'excessDiscount',
      name: '申请超标优惠',
      click: handleExcessDiscount,
    },
    {
      key: 'abnormalRefundOpen',
      name: '申请异常退单',
      click: handleAbnormalRefund,
    },
    {
      key: 'refundSign',
      name: '退单重签',
      click: handleRefundSign,
    },
    {
      key: 'refundBalance',
      name: '退余额',
      click: handleRefundBalance,
    },
    {
      key: 'ChargebackBtn',
      name: '退款',
      click: handleReFund,
    },
    {
      key: 'DrawingManagementBtn',
      name: '整装图纸',
      click: detailsInfo => drawingManagementHandle(detailsInfo),
    },
    {
      key: 'customizedDrawings',
      name: '定制图纸',
      click: detailsInfo => customizedDrawingsHandle(detailsInfo),
    },
    {
      key: 'addQuotaBtn',
      name: '新增报价',
      type: 'primary',
      click: handleAddQuotation,
    },
    {
      key: 'submitWorkBtn',
      name: '提开工',
      type: 'primary',
      click: handleSubmitWorkBtn,
    },
    {
      key: 'modifyCContractAAddress',
      name: '楼盘地址变更',
      click: handleChangeAddress,
    },
    {
      key: 'BIND_JD_ORDER',
      name: '关联京东订单',
      click: contactJD,
    },
    {
      key: 'START_JD_RECEIPT',
      name: '发起京东收款',
      click: addOrUpdatePaymentApply,
    },
    {
      key: 'applySpecialStartWork',
      name: '申请特殊开工',
      click: () => {
        setShowApproverSubmit(true)
      },
    },
  ])

  const [chooseBtns, setChooseBtns] = useState<any>([])

  const getOrderButton = () => {
    orderGetButton({ orderId: id }).then((res: any) => {
      const data: any = []
      res.map(item => {
        btns.map(eve => {
          if (item.buttonName === eve.name) {
            data.push(eve)
          }
        })
      })
      setChooseBtns(data)
    })
  }

  const reloadPage = async () => {
    await init()
    await getOrderButton()
  }

  const goBack = () => {
    navaigate('/order/list')
  }

  const handleJump = (jumpOrderIdList: any) => {
    window.open(`/order/list/details/${jumpOrderIdList?.[0]}`)
  }

  return (
    <SBack
      title={'订单详情'}
      level={2}
      extra={[<Space style={{flexWrap: 'wrap'}} className={styles.btns}>{chooseBtns.map(btn => getToolTip(btn))}</Space>]}
      goPath={goBack}
    >
      <div className={styles.baseBox}>
        {
          gaveActivityType === 'gave' ? (
            <div style={{ width: '100%', marginTop: '10px', cursor: 'pointer' }}>
              <img onClick={() => handleJump(gaveOrderIdList)} style={{ width: '100%'}} src={ actBannerAct } />
            </div>
          ) : null
        }
        {
          gainActivityType === 'gain' ? (
            <div style={{ width: '100%', marginTop: '10px', cursor: 'pointer' }}>
              <img onClick={() => handleJump(gainOrderIdList)} style={{ width: '100%'}} src={ actBannerActOrigin } />
            </div>
          ) : null
        }
        <div style={{ padding: '20px 15px 0px' }}>
          <STitle title={'基础信息'} />
          <SGeneralForms
            isDetail={true}
            configs={baseInfoConfig}
            detailsData={detailsInfo}
            ref={orderRef}
            formConfig={{ style: {} }}
          />
        </div>
        <SListTabs defaultActiveKey={'1'} items={items} hideExtra={false} />
        <AddQuotationDrawer
          title="新增报价"
          quoteGoodsId={detailsInfo?.id}
          open={open}
          setOpen={setOpen}
          fn={listRef1.current?.reload}
          reloadDetail={() => init()}
          detailsInfo={detailsInfo}
        ></AddQuotationDrawer>
        <ReFundDrawer
          title="申请退款"
          orderId={id}
          open={openRefund}
          detailsInfo={detailsInfo}
          setOpen={setOpenRefund}
        ></ReFundDrawer>
        <SubmitWork
          title="申请开工"
          open={submitWorkOpen}
          setOpen={setSubmitWorkOpen}
          orderId={id}
          reloadDetail={() => init()}
        ></SubmitWork>
        <StartWorkPending
            title="提交开工延期"
            open={startWorkPendingOpen}
            setOpen={setStartWorkPendingOpen}
            orderId={id}
        />
        {/* <StartWorkLock
            title="提交开工锁定"
            open={startWorkLockOpen}
            setOpen={setStartWorkLockOpen}
            orderId={id}
        /> */}
        <ExcessDiscount
          title="申请超标优惠"
          open={excessDiscountOpen}
          setOpen={setExcessDiscountOpen}
          detailsInfo={detailsInfo}
          orderId={id}
          fn={listRef1.current?.reload}
        />
        <AbnormalRefund
          title="申请异常退单"
          open={abnormalRefundOpen}
          setOpen={setAbnormalRefundOpen}
          orderId={id}
        />

        <RefundSign
          title="退单重签"
          quoteGoodsId={detailsInfo?.id}
          detailsInfo={detailsInfo}
          open={refundSignOpen}
          setOpen={setRefundSignOpen}
          fn={listRef1.current?.reload}
          orderId={id}
        />
        <RefundBalance
          title="退余额"
          quoteGoodsId={detailsInfo?.id}
          detailsInfo={detailsInfo}
          open={refundBalanceOpen}
          setOpen={setRefundBalanceOpen}
          fn={listRef1.current?.reload}
          orderId={id}
        />
        {openEditCommodityModal ? (
          <EditCommodityModal
            detailsInfo={detailsInfo}
            open={openEditCommodityModal}
            onCancel={() => setOpenEditCommodityModal(false)}
            reloadPage={reloadPage}
          />
        ) : null}

        <ChangeAddress
          title="楼盘地址变更"
          open={changeAddressOpen}
          setOpen={setChangeAddressOpen}
          detailsInfo={detailsInfo}
          orderId={id}
        />
        <LinkJd
          title="关联京东订单"
          open={linkToJDOpen}
          setOpen={setLinkToJDOpen}
          detailsInfo={detailsInfo}
          orderId={id}
          reloadDetail={init}
        />
        <AddJdPaymentAplly
          title="新增京东收款单"
          open={addJdOpen}
          setOpen={setAddJdOpen}
          detailsInfo={detailsInfo}
          orderId={id}
          reload={jdTableRef.current?.reload}
        ></AddJdPaymentAplly>
        <WhiteListApprove
          title={'收款白名单审批'}
          open={showApproverSubmit}
          id={''} //查看时需要传入id
          orderId={id}
          onClose={() => setShowApproverSubmit(false)}
          reload={() => { 
            reloadPage(); 
          }}
        />
        {
          predictStartTimeOpen?<ExpectedStartWorkTime
            title="通知客户选择开工日期"
            open={predictStartTimeOpen}
            setOpen={setPredictStartTimeOpen}
            detailsInfo={detailsInfo}
            orderId={id}
          />:null
        }
      </div>
    </SBack>
  )
}
